import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AUTHZ_ROLE_QUERY_KEY } from "../config";
import { createAuthzRole, fetchAuthzRoles, updateAuthzRoleStatus } from "../repo";
import type { AuthzRoleCreateMutation, AuthzRoleListQuery, AuthzRoleStatus } from "../types";

/** 编排角色分页查询、新增和状态切换。 */
export function useAuthzRoleListRuntime(query: AuthzRoleListQuery) {
  const queryClient = useQueryClient();
  const rolesQuery = useQuery({
    queryKey: [...AUTHZ_ROLE_QUERY_KEY, query],
    queryFn: () => fetchAuthzRoles(query),
  });
  const createMutation = useMutation({
    mutationFn: (payload: AuthzRoleCreateMutation) => createAuthzRole(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AUTHZ_ROLE_QUERY_KEY }),
  });
  const statusMutation = useMutation({
    mutationFn: ({ roleId, status }: { roleId: number; status: AuthzRoleStatus }) =>
      updateAuthzRoleStatus(roleId, status),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: AUTHZ_ROLE_QUERY_KEY }),
  });
  return { rolesQuery, createMutation, statusMutation };
}
